import { WithdrawalMode } from '@generated/graphql';
import type { TranslatedString } from '@interfaces/shared';
import { MenuItem } from '@ovComponents/2-component/menuItem/menuItem';
import { SelectField } from '@ovComponents/2-component/selectField/selectField';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocalization } from '../../../../../hooks/useLocalization';

export type WithdrawalModeSelectProp = {
  disclaimer: TranslatedString | undefined;
  mode: WithdrawalMode;
  onModeChange: (mode: WithdrawalMode) => void;
};

export const WithdrawalModeSelect = ({
  disclaimer,
  mode,
  onModeChange,
}: WithdrawalModeSelectProp) => {
  const { t } = useTranslation('components');
  const { translateBackendString } = useLocalization();
  const disclaimerText = translateBackendString(disclaimer);

  return (
    <>
      <SelectField
        label={t('transferModal.withdrawalMode')}
        testId='withdraw-form-withdrawal-mode'
        value={mode}
        onChange={(event: { target: { value: WithdrawalMode } }) =>
          onModeChange(event.target.value)
        }
        fullWidth
        sx={{ mb: 2 }}
      >
        <MenuItem
          value={WithdrawalMode.Gross}
          data-testid='withdrawal-mode-gross'
        >
          {t('transferModal.gross')}
        </MenuItem>
        <MenuItem value={WithdrawalMode.Net} data-testid='withdrawal-mode-net'>
          {t('transferModal.net')}
        </MenuItem>
      </SelectField>
      {disclaimerText && (
        <Box sx={{ mb: 2 }}>
          <Typography
            variant='labelSmall'
            color='textSecondary'
            component='div'
          >
            <ReactMarkdown remarkPlugins={[remarkGfm]} linkTarget='_blank'>
              {disclaimerText}
            </ReactMarkdown>
          </Typography>
        </Box>
      )}
    </>
  );
};
